/** Thousands-separated number formatting for stats and table cells. */
export const fmt = (n: number) => n.toLocaleString("en-US");
